import useApiMutation from '@src/hooks/useApiMutation';

import {
  ControlLockModeEdited,
  ControlLockModeEditedResponse,
} from '@src/types/ControlLockModeEdit';

export default () => {
  const createControlLock = useApiMutation<
    ControlLockModeEdited,
    ControlLockModeEditedResponse
  >({
    apiPath: '/controls-lock',
    method: 'POST',
    useV2API: true,
  });

  return {
    createControlLock,
  };
};
